export default "__VITE_ASSET__DLs_ULDv__"